import PropTypes from "prop-types"
import React, { useState } from "react"
import HubspotFormEmbed from "components/HubspotFormEmbed"
import { richTextToHtml } from "utils/richTextToHtml"
import * as css from "./EmbedFormSection.module.css"
import Section from "components/Layout/Section"
import SectionHeader from "components/Layout/SectionHeader"

/**
 * Sidebar + native HubSpot embed layout. Use for pages whose form should
 * just collect what HubSpot has configured (newsletter signups, gated PDF
 * downloads, etc.) rather than the full sales-qualification ContactForm
 * with its meeting picker and freemail branching. Wired up for the
 * `newsletter-form` and `gated-download-form` section types in
 * LocalPageTemplate; the rendering is identical, the section names exist
 * to communicate authoring intent.
 */
function EmbedFormSection({
  label,
  heading,
  hubspotForm,
  leftSideRichText,
  leftSideContactMessage,
  successMessage,
}) {
  const [submitted, setSubmitted] = useState(false)
  const successMessageDoc = successMessage?.raw
    ? JSON.parse(successMessage.raw)
    : null
  const leftSideRichTextDoc = leftSideRichText?.raw
    ? JSON.parse(leftSideRichText.raw)
    : null
  const leftSideContactMessageDoc = leftSideContactMessage?.raw
    ? JSON.parse(leftSideContactMessage.raw)
    : null

  return (
    <Section>
      <SectionHeader
        level="h1"
        label={label}
        title={heading}
        constrained
        margin
      />
      <div className={css.segment}>
        <div className="grid grid-cols-1 md:grid-cols-[5fr_11fr] gap-8">
          <div className={css.infoColumn}>
            {leftSideRichTextDoc && (
              <div
                className={css.leftSideMessage}
                dangerouslySetInnerHTML={{
                  __html: richTextToHtml(leftSideRichTextDoc),
                }}
              />
            )}
            {leftSideContactMessageDoc && (
              <div
                className={css.leftSideMessage}
                dangerouslySetInnerHTML={{
                  __html: richTextToHtml(leftSideContactMessageDoc),
                }}
              />
            )}
          </div>
          <div className={css.formColumn}>
            {submitted && successMessageDoc ? (
              <div
                className={css.message}
                dangerouslySetInnerHTML={{
                  __html: richTextToHtml(successMessageDoc),
                }}
              />
            ) : (
              hubspotForm?.formId && (
                <HubspotFormEmbed
                  formId={hubspotForm.formId}
                  trackSubmit={hubspotForm.trackSubmit}
                  onSubmit={() => setSubmitted(true)}
                  submitText={hubspotForm.submitText}
                />
              )
            )}
          </div>
        </div>
      </div>
    </Section>
  )
}

EmbedFormSection.propTypes = {
  label: PropTypes.string,
  heading: PropTypes.string,
  hubspotForm: PropTypes.shape({
    formId: PropTypes.string.isRequired,
    trackSubmit: PropTypes.string,
  }),
  leftSideRichText: PropTypes.shape({ raw: PropTypes.string }),
  leftSideContactMessage: PropTypes.shape({ raw: PropTypes.string }),
  successMessage: PropTypes.shape({ raw: PropTypes.string }),
}

export default EmbedFormSection
